// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"afa52953","34":"a2ff406f","425":"0d0b4610","510":"0be14eee","532":"414d80e7","633":"805d5417","922":"12d674d6","937":"be4811bb","972":"cc6b8157"}[chunkId] + ".chunk.js";
};